import React from "react";
import { useTranslation } from "react-i18next";
import { cn } from "../../lib/utils";

interface ModalProps {
    onClose: () => void;
}

export default function Modal({ onClose }: ModalProps) {
    const { t } = useTranslation();

    // function handleDownload() {
    //     const userAgent = navigator.userAgent || navigator.vendor || "";

    //     const isIOS = /iPad|iPhone|iPod/.test(userAgent);
    //     const isAndroid = /android/i.test(userAgent);

    //     if (isIOS) {
    //         window.location.href =
    //             "https://apps.apple.com/us/app/zabehaty-%D8%B0%D8%A8%D9%8A%D8%AD%D8%AA%D9%8A/id1227769641";
    //     } else if (isAndroid) {
    //         window.location.href =
    //             "https://play.google.com/store/apps/details?id=com.atp.zabehati";
    //     } else {
    //         window.open("https://zabehaty.com", "_blank");
    //     }
    // }

    function handleDownload() {
        const userAgent = navigator.userAgent || navigator.vendor || "";
        const platform = navigator.platform || "";

        const isIOS = /iPad|iPhone|iPod/i.test(userAgent);
        const isAndroid = /android/i.test(userAgent);
        const isWindows = /Win/i.test(platform);
        const isMac = /Mac/i.test(platform);

        const appStoreURL =
            "https://apps.apple.com/us/app/zabehaty-%D8%B0%D8%A8%D9%8A%D8%AD%D8%AA%D9%8A/id1227769641";
        const playStoreURL =
            "https://play.google.com/store/apps/details?id=com.atp.zabehati";

        if (isIOS) {
            window.location.href = appStoreURL;
        } else if (isAndroid) {
            window.location.href = playStoreURL;
        } else if (isWindows) {
            window.open(playStoreURL, "_blank");
        } else if (isMac) {
            window.open(appStoreURL, "_blank");
        } else {
            // Unknown or Linux
            // eslint-disable-next-line no-restricted-globals
            const choice = confirm("Open download links for both stores?");
            if (choice) {
                window.open(appStoreURL, "_blank");
                window.open(playStoreURL, "_blank");
            }
        }
    }

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="relative w-full max-w-xl rounded-2xl bg-white p-8 shadow-xl">
                <button
                    onClick={onClose}
                    className="absolute right-4 top-4 text-gray-500 transition hover:text-gray-800"
                    aria-label="Close"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>
                </button>

                <div className="mb-8 flex justify-center">
                    <img
                        src="/delete-icon.png"
                        alt="Warning"
                        className="h-10 w-10"
                    />
                </div>
                <div className="flex flex-col gap-4">
                    <span className="mb-8 text-center text-xl text-foreground">
                        {t("modals.adahy-text")}
                    </span>
                </div>
                <div className="flex gap-4">
                    <button
                        className={cn(
                            "flex-1 rounded-xl bg-primary py-4 text-white transition hover:opacity-80",
                        )}
                        onClick={handleDownload}
                    >
                        {t("modals.adahy-download")}
                    </button>
                </div>
            </div>
        </div>
    );
}
